import React from 'react';

import './TitlePage.css';

const LoadingPage = () => (
  <div className="title-content-block">
    <div className="row justify-content-center">
      <div className="col-4">
        <p>
          Loading...
        </p>
      </div>
    </div>
  </div>
);

export default LoadingPage;
